import {injectable} from "inversify";
import {IOption} from "../components/inputs/select-dropdown/select-dropdown";
import {rootContainer, TYPE} from "./container/root";
import {IApiResponse, IHttpService} from "./http-service";

interface ITimezoneList {
    list: IOption[];
}
export enum DATE_FORMAT {
    FIRST = 'dd/MM/yyyy',
    SECOND = 'MM/dd/yyyy',
    THIRD = 'dd MMM yyyy',
    FOURTH = 'MMM dd, yyyy'
}

export enum TIME_FORMAT {
    TWENTY_FOUR = '24',
    AM_PM = '12'
}

export const TIME_FORMAT_TRANSLATIONS_MAP = {
    [TIME_FORMAT.TWENTY_FOUR]: '24_HOURS',
    [TIME_FORMAT.AM_PM]: '12_HOURS'
}

@injectable()
export default class TimezoneService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);
    
    public async loadTimezoneList(){
        const res = await this.httpService.get<IApiResponse<ITimezoneList>>(`/rms-api/timezone-list`);
        return res.payload;
    }
    
    
}

